// extracted by mini-css-extract-plugin
module.exports = {"Error":"Error_Error__N8IOA"};